import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Button, ButtonProps } from 'shared/mui/Buttons';

export type FilterClearButtonProps = ButtonProps & {
  visible?: boolean;
};

export const FilterClearButton: React.FC<FilterClearButtonProps> = ({
  label,
  color = 'primary',
  visible = true,
  ...restProps
}) => {
  const translate = useTypedTranslate();

  return (
    <Button
      color={color}
      label={label || translate('app.filter.clearFilter')}
      sx={{
        display: visible ? 'initial' : 'none',
      }}
      {...restProps}
    />
  );
};
